import styled from 'styled-components'

const PlusPill = styled.span`
    display: inline-block;
    background: ${(props) => props.theme.palette.brand.blue};
    color: white;
    font-weight: 700;
    font-size: 10px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    padding: 2px 7px;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
    vertical-align: middle;
    flex-shrink: 0;
    white-space: nowrap;
    line-height: normal;
`

export default PlusPill
